import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Profiledata from "../data/profileData";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import checkLogin from "../auth/checkLogin";
const baseUrl = process.env.REACT_APP_BASE_URL;

const Profile = () => {
  const { id } = useParams();
  const response = Profiledata.find((e) => e.id == id);

  return (
    <div>
      <div className="bg-gradient-to-tr from-[#f0f0f0] to-[#e1e1e1]">
        <div className="md:p-10 md:mx-44">
          <div className="flex flex-col gap-10 mx-5 py-5">
            <div className="bg-white rounded-lg shadow-xl flex">
              <div className="flex gap-5 lg:gap-20 flex-col lg:flex-row lg:items-center justify-center m-10">
                <div className="">
                  <img
                    className="border-4 rounded-md shadow-xl w-[150px] lg:min-w-[200px]"
                    src={response.image ? response.image : null}
                    alt="img"
                  />
                </div>
                <div className="">
                  <div className="flex flex-col gap-2">
                    <h3 className="text-2xl md:mt-5 md:text-4xl border-b-4 font-semibold">
                      {response.name}
                    </h3>
                    <div className="flex flex-col gap-2">
                      <p className="text-lg md:text-xl text-gray-700">
                        {response.domain ? response.domain : null}
                      </p>
                    </div>
                    <div className="text-gray-500">
                      <p>{response.contact ? response.contact : ""}</p>
                      <p>{response.email ? response.email : ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="flex flex-col gap-5 lg:w-3/5">
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl mb-2 w-max font-semibold border-b-2">
                    About :{" "}
                  </h3>
                  <p className="text-md md:text-lg text-gray-500">
                    {response.about ? response.about : ""}
                  </p>
                </div>
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl w-max font-semibold border-b-2">
                    Experience :{" "}
                  </h3>
                  <ul>
                    {response.experience.map((para) => (
                      <li className="">
                        <h3 className="text-lg lg:text-xl font-medium mb-2 mt-2">
                          ‣ {para.title ? para.title : ""} -{" "}
                        </h3>
                        <p className="text-gray-500 text-md md:text-lg">
                          {para.description ? para.description : ""}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl mb-2 w-max font-semibold border-b-2">
                    Skills :{" "}
                  </h3>
                  <p className="flex flex-wrap gap-4">
                    {response.skills.map((para) => (
                      <p className="text-lg md:text-lg rounded-xl bg-green-200/50 text-green-700 border-green-400 px-2 py-1 tracking-widest border-[2px]">
                        {para.skill ? para.skill : ""}
                      </p>
                    ))}
                  </p>
                </div>
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl mb-2 w-max font-semibold border-b-2">
                    Education :{" "}
                  </h3>
                  <p className="text-md md:text-lg text-gray-500">
                    {response.education ? response.education : ""}
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 lg:w-2/5">
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl mb-2 w-max font-semibold border-b-2">
                    Job :{" "}
                  </h3>
                  <p className="text-md md:text-lg text-gray-500">
                    {response.job ? response.job : ""}
                  </p>
                </div>
                <div className="flex flex-col gap-2 bg-white p-10 rounded-lg shadow-xl">
                  <h3 className="text-2xl mb-2 w-max font-semibold border-b-2">
                    Company :{" "}
                  </h3>
                  <p className="text-md md:text-lg text-gray-500">
                    {response.company ? response.company : ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
